<template>
  <div class="checkLabel2d" v-loading="loadingDataBoolean" element-loading-text="问题数据获取中...">
    <div class="table">
      <el-table 
        height="100%" 
        border 
        :data="tabData" 
        highlight-current-row 
        :header-cell-style="headerCellStyle" 
        class="is-grey" 
        size="small" 
        ref="multipleTable" 
        row-key="questionId"
        header-cell-class-name="table-header" 
        @selection-change="handleSelectionChange" 
        @row-click="openDetails" 
        @row-dblclick="handelRowDblclick" 
        @filter-change="handleFilterChange" 
        style="width: 100%" 
      >
        <el-table-column type="selection" width="30" :reserve-selection="true"  align="center" ></el-table-column>
        <el-table-column show-overflow-tooltip width="90px"  align="center"  :filters="filtrate.specList" prop="specName" label="专业"  column-key="specList" v-slot='{row}'>
          <span>{{ row.multiSpecList | specNameFilters }}</span>
        </el-table-column>
        <el-table-column show-overflow-tooltip :filters="filtrate.checkTypeList" prop="qmType" label="问题类型" align="center" column-key="checkTypeList" width="100"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip :filters="filtrate.severityLevelList" width="90" prop="problemType" label="严重等级" align="center" column-key="severityLevelList" ></el-table-column> -->
        <el-table-column show-overflow-tooltip :filters="filtrate.statusList" width="100" prop="queStatus" label="问题状态" align="center" column-key="statusList" >
          <template slot-scope="scope" >
            <div @click.stop="currentQuestionId = scope.row.questionId" style="cursor:pointer">
              <el-popover 
                placement="bottom" 
                width="300" 
                :key="scope.row.questionId"  
                trigger="manual" 
                :value="currentQuestionId == scope.row.questionId" 
                :ref="`popover${scope.row.questionId}`"
                v-model="scope.row.popShow"
              >
                <el-form ref="formstatus" :rules="statusRules" :model="formstatus" class="statusForm" size="mini" label-position="top">
                  <el-form-item label="问题状态:" prop="statusId">
                    <el-select size="small"  v-model="formstatus.statusId" placeholder="请选择" >
                      <el-option v-for="item in dicData.dealList" :key="item.id" :label="item.cnName" :value="item.id"> </el-option>
                    </el-select>
                  </el-form-item>
                  <!-- <el-form-item label="说明:" >
                    <el-input v-model="formstatus.content" placeholder="请输入说明" type="textarea"  maxlength="200" show-word-limit ></el-input>
                  </el-form-item> -->
                  <el-form-item  class="footer">
                    <el-button size="mini" @click="closepop(scope.row)">取 消</el-button>
                    <el-button size="mini" type="primary" @click="changeStatus(scope.row)" >确 定</el-button>
                  </el-form-item>
                </el-form>
                <div class="statusChange" slot="reference">
                  <p class="status" v-if="scope.row.queStatus === '待修改'" style="background:#FCE9DF;color:#eb5757" @click="dealStatus(scope.row)" > {{ scope.row.queStatus }} </p>
                  <p class="status" v-if="scope.row.queStatus === '已修改'" style="background:#FFFFDF;color:#eac100;height:24px" @click="dealStatus(scope.row)" > {{ scope.row.queStatus }} </p>
                  <p class="status" v-if="scope.row.queStatus === '已复核'" style="background:#E5F1FF;color:#3791FB;height:24px" @click="dealStatus(scope.row)" > {{ scope.row.queStatus }} </p>
                  <p class="status" v-if="scope.row.queStatus === '不修改'" style="background:#F2F2F2;color:#8b8888;height:24px" @click="dealStatus(scope.row)" > {{ scope.row.queStatus }} </p>
                  <p class="status" v-if="scope.row.queStatus === '已取消'" style="height:24px" @click="dealStatus(scope.row)" > {{ scope.row.queStatus }} </p>
                  <p class="status" v-if="scope.row.queStatus === '已销项'" style="background:#DEF6E4;color:#00B632;height:24px" @click="dealStatus(scope.row)" > {{ scope.row.queStatus }} </p>
                </div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="checkContent" min-width="160" label="问题描述" align="center" ></el-table-column>
        <el-table-column show-overflow-tooltip label="问题回复" prop="replyContent" min-width="120" :cell-style="{padding: '0 10px'}" align="center">
          <template v-slot="{row}">
            <div>{{ row.replyContent }}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="fileName" width="190" label="文件名" align="center"></el-table-column>


        <!-- :sortable="true" :sort-method="sortProblemType"   取消等级排序 -->
        <el-table-column show-overflow-tooltip :filters="filtrate.modifierList" width="100" prop="modifierName" label="修改方" align="center" column-key="modifierList" >
          <template slot-scope="scope" >
            <span class="modifier">{{modifierNames(scope.row)}}</span>
          </template>
        </el-table-column>
        
        <!-- <el-table-column show-overflow-tooltip :filters="filtrate.subItemList" prop="stageChildName" label="子项" align="center" column-key="subItemList" ></el-table-column> -->
        <el-table-column show-overflow-tooltip width="80px" :filters="filtrate.createUserList" prop="creatorName" label="创建人" align="center" column-key="createUserList" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="createDate" width="100" label="创建时间" align="center" ></el-table-column>
        <!-- <el-table-column show-overflow-tooltip :filters="filtrate.problemSourceList" prop="source" label="问题来源" align="center" column-key="problemSourceList" ></el-table-column> -->
      </el-table>
    </div>
    <div class="page">
      <page :page="page" @handleSizeChange="handleSizeChange" @handleCurrentChange="fetchData" v-show="page.totalCount > 0" style="float:right;margin-top:10px"></page>
    </div>
  </div>
</template>

<script>
const filterParams=()=>({
  checkTypeList:[],//意见类型
  createUserList:[],//创建人
  modifierList:[],//修改方
  problemSourceList:[],//问题来源
  severityLevelList:[],//	严重等级
  specList:[],//文件专业
  specStageChildVos:[],//专业、阶段、子项
  stageList:[],//	阶段
  statusList:[],//问题状态
  subItemList:[],//子项
})
import requestIssueMg from "@/CommonDP/service/question-service";
import page from "./page.vue"
import question from "@/xgzdService/question-service"
import { mapState } from 'vuex'
export default {
  props:['searchFileName','typeArray'],
  components:{ page },
  filters: {
    specNameFilters(list) {
      return list.map(({ specName }) => specName).join(",");
    },
  },
  data(){
    return{
      currentQuestionId:null,
      dataRow:'',
      loadingDataBoolean:false,
      prjID:'',
      tabData:[],
      multipleSelection:[],//选中的数据
      clickTimeId:'',
      filtrate: filterParams(),
      selectForm:{
        statusIdList:[],//问题状态
        problemTypeIdList:[],//严重等级
        modifierIdList:[],//修改方
        qmTypeIdList:[],//意见类型
        specIdList:[],//专业类型
        stageChildIdList:[],//子项
        createUserIdList:[],//创建人
        sourceList:[],//问题来源
      },
      popover:{},
      page:{
        totalCount:0,
        pageNum: 1, // 当前页
        pageSize: 20, // 每页限制条数
      },
      formstatus:{//修改问题状态
        statusId:'',//问题id
        content:'',
      },
      statusRules:{
        statusId: [ { required: true, message: "问题状态不可为空", trigger: "change" }, ],
      },
      dicData:{
        statusList:[],
        dealList:[],
        modifierList:[]
      },
      row:{}
    }
  },
  computed:{
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      messageInfo: state => state.XtDesign.messageObj,
      userId: state => state.user.userId,

    }),
    searchParams(){
      const {statusIdList,problemTypeIdList,modifierIdList,qmTypeIdList,specIdList,stageChildIdList,createUserIdList,sourceList} =this.selectForm,
      params={
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        prjId: this.prjID,
        keyword: this.searchFileName,
        sortType: "1" ,// sortType=0升序 sortType=1降序
        fileTypeList:this.typeArray,
        statusIdList,problemTypeIdList,modifierIdList,qmTypeIdList,
        multiSpecList: specIdList, // 参数后端调整
        stageChildIdList,createUserIdList,sourceList
      }
      return params
    },
    statusParams(){
      const {statusId,content}=this.formstatus,
      {questionId,queStatusId,queStatus} = this.dataRow,
      params={
        content,
        prjId: this.prjID,
        idList: [questionId],
        statusId: queStatusId,
        statusName: queStatus,
        toStatusId: statusId,
        toStatusName: this.dicData.allStatusList.find(ele=>ele.id == statusId).cnName
      }
      return params
    }
  },
  watch:{
    'prjInfo': {
      deep: true,
      handler: function ({prjId},oldValue) {
        if (prjId) {
          this.prjID = prjId;
          this.getInit();
        }
      }
    }
  },
  created(){
    this.prjID = this.prjInfo.prjId;
  },
  mounted(){
    this.getInit();
  },
  methods:{
    sortProblemType(left, right) {
      const sortList = ['D', 'C', 'B', 'A']
      const getIndex = (val) => sortList.findIndex(key => val?.problemType === key)
      return getIndex(left) - getIndex(right)
    },
    dealStatus(row){
      const {creatorId,queStatusId,queStatus,questionId,modifierId,modifierList} =row;
      this.formstatus.statusId=''
      this.formstatus.content=''
      // this.$refs[`popover${questionId}`].showPopper = true;
      this.row.popShow = false;
      row.popShow = true;
      this.row = row;
      this.$refs.formstatus.clearValidate();
      this.dicData.dealList=this.dicData.allStatusList.filter(item=>item.cnName!==queStatus )
      // if(creatorId == this.userId && modifierList.some(ele=>ele.modifierId == this.userId)){//同一个人
      //   if(queStatus == "待修改"){
      //     this.dicData.dealList=this.dicData.statusList.filter(ele=>ele.cnName=="已修改"|| ele.cnName=="无效")
      //   }else if(queStatus == "已修改"){
      //     this.dicData.dealList=this.dicData.statusList.filter(ele=>ele.cnName=="已复核"||ele.cnName=="待修改"||ele.cnName=="无效")
      //   }else if(queStatus == "已复核"){
      //     this.dicData.dealList=this.dicData.statusList.filter(ele=>ele.cnName=="待修改"||ele.cnName=="无效")
      //   }else if(queStatus == "无效"){
      //     this.dicData.dealList=this.dicData.statusList.filter(ele=>ele.cnName=="待修改")
      //   }
      // }else{
      //   //创建人
      //   if(creatorId == this.userId){
      //     if(queStatus == "待修改"){
      //       this.dicData.dealList=this.dicData.statusList.filter(ele=>ele.cnName=="无效")
      //     }else if(queStatus == "已修改"){
      //       this.dicData.dealList=this.dicData.statusList.filter(ele=>ele.cnName=="已复核"||ele.cnName=="待修改"||ele.cnName=="无效")
      //     }else if(queStatus == "已复核"){
      //       this.dicData.dealList=this.dicData.statusList.filter(ele=>ele.cnName=="待修改"||ele.cnName=="无效")
      //     }else if(queStatus == "无效"){
      //       this.dicData.dealList=this.dicData.statusList.filter(ele=>ele.cnName=="待修改")
      //     }
      //   }else if(modifierList.some(ele=>ele.modifierId == this.userId)){//处理人
      //     if(queStatus == "待修改"){
      //       this.dicData.dealList=this.dicData.statusList.filter(ele=>ele.cnName=="已修改")
      //     }else if(queStatus == "已修改"){
      //       this.dicData.dealList=this.dicData.statusList.filter(ele=>ele.cnName=="待修改")
      //     }else{
      //       this.dicData.dealList=this.dicData.statusList.filter(ele=>ele.cnName==queStatus)
      //     }
      //   }else{
      //     this.$refs[`popover${questionId}`].showPopper = false;
      //     this.$message.warning('很抱歉,仅问题创建人或者问题处理人有修改问题状态的权限')
      //   }
      // }
      this.$nextTick(()=>{
        // this.formstatus.statusId = queStatusId
      })
    },
    modifierNames(row){
      let names= [];
      if(row.modifierList&&row.modifierList.length >0 ){
        row.modifierList.forEach(ele=>{
          names.push(ele.modifierName)
        })
      }
      return names.join(",")
    },
    getInit(){
      this.loadingDataBoolean =true;
      this.page.pageNum = 1;
      this.queQuestionSearchList()// 表头筛选数据
      this.queryEvent();
      this.hidePopover();
    },
    getInitOld(){
      this.loadingDataBoolean =true;
      this.queQuestionSearchList()// 表头筛选数据
      this.queryEvent()
    },
    // 表头筛选数据
    async queQuestionSearchList() {
      this.filtrate=filterParams()
      let params = {
        prjId: this.prjID,
        fileTypeList: this.typeArray
      }
      const res = await question.getFilterDicCheckLabel(params)
      if(res.result == '0'){
        const {checkTypeList,createUserList,
          userList: userDicList,
          roleList: roleDicList,
          allStatusList,
          problemSourceList,severityLevelList,specList,specStageChildVos,statusList}=res.data;
        this.dicData.statusList=statusList
        this.dicData.allStatusList=allStatusList
        // this.dicData.modifierList=modifierList;
        let roleList = { label: '角色', options: res.data.allRoleList };
        let userList = { label: '用户', options: res.data.allUserList };
        this.dicData.modifierList = [roleList, userList]
        //意见类型
        if(!!checkTypeList && checkTypeList.length>0){
          this.filtrate.checkTypeList=[]
          checkTypeList.forEach(element => {
            this.filtrate.checkTypeList.push({
              text: element.cnName,
              value: element.id,
            });
          });
        }
        //创建人
        if(!!createUserList && createUserList.length>0){
          this.filtrate.createUserList=[]
          createUserList.forEach(element => {
            this.filtrate.createUserList.push({
              text: element.name,
              value: element.userId,
            });
          });
        }
        // //修改方
        // if(!!modifierList && modifierList.length>0){
        //   this.filtrate.modifierList=[]
        //   modifierList.forEach(element => {
        //     this.filtrate.modifierList.push({
        //       text: element.name,
        //       value: element.userId,
        //     });
        //   });
        // }
        // 修改方字典生成
        const getModifyMap = (arr) => (arr || []).map(item => {
          return { text: item.cnName, value: item.id}
        }).filter((f, index ) => {
          return (arr || []).findIndex(v => v.id === f.value) === index
        })
        this.filtrate.modifierList=[
          {
            group: '用户',
            filters: getModifyMap(userDicList)
          },
          {
            group: '角色',
            filters: getModifyMap(roleDicList)
          }
        ]

        //问题来源
        if(!!problemSourceList && problemSourceList.length>0){
          this.filtrate.problemSourceList=[]
          problemSourceList.forEach(element => {
            this.filtrate.problemSourceList.push({
              text: element.cnName,
              value: element.cnName,
            });
          });
        }
        //严重等级
        if(!!severityLevelList && severityLevelList.length>0){
          this.filtrate.severityLevelList=[]
          severityLevelList.forEach(element => {
            this.filtrate.severityLevelList.push({
              text: element.cnName,
              value: element.dicId,
            });
          });
        }
        //专业、阶段、子项
         if(!!specList && specList.length>0){
           this.filtrate.specList=[]
          specList.forEach(element => {
            this.filtrate.specList.push({
              text: element.cnName,
              value: element.dicId,
            });
          });
        }
       
        //问题状态
        if(!!statusList && statusList.length>0){
          this.filtrate.statusList=[]
          statusList.forEach(element => {
            this.filtrate.statusList.push({
              text: element.cnName,
              value: element.dicId,
            });
          });
        }
       
      }
    },
    //当前单页数量
    handleSizeChange(val){
      this.page.pageSize = val
      this.page.pageNum = 1;
      this.queryEvent()
    },
    //分页
    fetchData(val){
      this.page.pageNum = val;
      this.queryEvent()
    },
    refresh(){
      this.queryEvent()
    },
    // 查询表格
    async queryEvent() {
      this.tabData =[];
      const res = await requestIssueMg.getDrawingQuestionPageList(this.searchParams)
      if(res.result == '0'){
        this.tabData = res.data||[];
        this.loadingDataBoolean =false;
        this.page.pageNum = res.pageIndex;
        this.page.totalCount = res.totalCount;
        this.page.pageSize = res.pageSize
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$emit("checkData",val)
    },
    // 行单击事件
    openDetails(row) {
      clearTimeout(this.clickTimeId);
      this.clickTimeId = setTimeout(() => {
        this.$emit("openDetail", row, this.tabData);
      }, 300);
    },
    // 行双击事件
    handelRowDblclick(row) {
      clearTimeout(this.clickTimeId);

      this.$refs.multipleTable.toggleRowSelection(row);
    },
    handleFilterChange(filters) {
      //问题状态
      if (filters.statusList) {
        this.selectForm.statusIdList = filters.statusList;
      }
      //严重等级
      if (filters.severityLevelList) {
        this.selectForm.problemTypeIdList = filters.severityLevelList;
      }
      //修改方
      if (filters.modifierList) {
        this.selectForm.modifierIdList = filters.modifierList;
      }
      //意见类型
      if (filters.checkTypeList) {
        this.selectForm.qmTypeIdList = filters.checkTypeList;
      }
      //专业类型
      if (filters.specList) {
        this.selectForm.specIdList = filters.specList;
      }
      //子项
      if (filters.subItemList) {
        this.selectForm.stageChildIdList = filters.subItemList;
      }
      //创建人
      if (filters.createUserList) {
        this.selectForm.createUserIdList = filters.createUserList;
      }
      //问题来源
      if (filters.problemSourceList) {
        this.selectForm.sourceList = filters.problemSourceList;
      }
      this.page.pageNum = 1;
      this.queryEvent()

    },
    closepop(row){
      // this.$refs[`popover${id}`].showPopper = false;
      row.popShow = false;
      this.currentQuestionId = null
    },
    async changeStatus(row){
      this.dataRow = row;
      this.$refs.formstatus.validate(async (valid) => {
        if (valid) {
          try {
            const res = await question.drawingannotationupdateStatus(this.statusParams);
            if(res.result =='0'){
              this.$message.success("修改成功")
              this.$refs[`popover${row.questionId}`].showPopper = false;
              this.queryEvent()
              this.isRead = true;
              this.currentQuestionId = null
            }
          } catch (error) {
            this.$refs[`popover${row.questionId}`].showPopper = false;
          }
        }
      })
    },
    headerCellStyle({ rowIndex }) {
      if (rowIndex === 5) return "background: rgb(247, 249, 255)";
    },
    hidePopover() {
      this.tabData.forEach(item => {
        item.popShow = false;
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.checkLabel2d{
  width: 100%;
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 5px 15px;
  box-sizing: border-box;
  .statusChange{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .status{
    border-radius: 4px;
    max-width: 88px;
    padding: 0 15px;
    cursor: pointer;
  }
  .page{
    float: right;
  }
  .table{
    height: calc(100% - 50px);
  }

  ::v-deep .el-tooltip{
    padding: 0 10px;
  }
}
.modifier{
  line-height: 23px;
  font-size: 14px;
}
</style>

